import { Backlight } from '@sohanscript/ui/animated/backlight';
import * as m from 'motion/react-m';
import * as React from 'react';
import { MotionProvider } from './motion';

export const StackCircle = ({
	image,
	label,
	renderImage,
}: {
	image: string;
	label: string;
	/** INFO: inject a Sanity/optimised image component; defaults to a plain <img>. */
	renderImage?: (props: { src: string; className?: string }) => React.ReactNode;
}) => (
	<MotionProvider feature="domMax">
		<m.div
			drag
			dragConstraints={{ left: 0, right: 0, top: 0, bottom: 0 }}
			title={label}
			className="grid size-10 cursor-grab place-content-center rounded-full border border-foreground/30 bg-transparent p-1 active:cursor-grabbing md:size-14 md:p-3"
		>
			{image &&
				(renderImage ? (
					renderImage({
						src: image,
						className:
							'filter-[url(#primary-color-filter)] pointer-events-none h-16 w-16 object-contain',
					})
				) : (
					<Backlight blur={20}>
						<img
							alt={label}
							className="filter-[url(#primary-color-filter)] pointer-events-none h-16 w-16 object-contain"
							src={image}
							width={50}
							height={50}
						/>
					</Backlight>
				))}
		</m.div>
	</MotionProvider>
);
